import { ServiceUsingCountLimiter } from "@/services/license/license-limiters/base-limiters/service-using-count-limiter";
import { LicenseName } from "@/data/license.data";
import { getUserUniqueTextToSpeechUsingCountLimit } from "@/actions/db/user-unique-dataset-limits";

export const trialTtmsCount = 1;
export const starterTtmsDayCount = 20;
export const creatorTtmsDayCount = 40;
export const studioTtmsDayCount = 100;

export class TextToSpeechCountLimiter extends ServiceUsingCountLimiter {
  getPlanLimit(license: LicenseName): number {
    switch (license) {
      case "Trial":
        return trialTtmsCount;
      case "Basic":
        return trialTtmsCount;
      case "Starter":
        return starterTtmsDayCount;
      case "Creator":
        return creatorTtmsDayCount;
      case "Studio":
        return studioTtmsDayCount;
      case "Premium":
        return Infinity;
      case "Ultimate":
        return Infinity;
    }
  }

  getUniqueLimit(userId: string): Promise<number | null> {
    return getUserUniqueTextToSpeechUsingCountLimit(userId);
  }
}
